document.addEventListener('DOMContentLoaded', () => {
  const filterBtn    = document.querySelector('[data-mtrx-filter-toggle]');
  const filterPanel  = document.getElementById('mtrx-filters');
  const filterClose  = document.querySelector('[data-mtrx-filter-close]');
  const overlay      = document.querySelector('[data-mtrx-overlay]');
  const sortSelect   = document.querySelector('[data-mtrx-sort]');

  function openFilters() {
    filterPanel?.classList.add('is-open');
    filterPanel?.setAttribute('aria-hidden', 'false');
    overlay?.classList.add('is-open');
    filterBtn?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeFilters() {
    filterPanel?.classList.remove('is-open');
    filterPanel?.setAttribute('aria-hidden', 'true');
    overlay?.classList.remove('is-open');
    filterBtn?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  filterBtn?.addEventListener('click', openFilters);
  filterClose?.addEventListener('click', closeFilters);
  overlay?.addEventListener('click', closeFilters);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeFilters();
  });

  sortSelect?.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    window.location.href = url.toString();
  });
});
